import { Grid } from '@farewill/ui'

import InputFloating from 'components/form/input-floating'
import { getItemsTotals } from 'routes/probate-estate/fact-find/get-totals'
import { ProbateEstateItem } from 'lib/models/probate-estate'
import { PUBLIC_SHAREHOLDING_SCHEMA } from 'lib/probate/estate-questionnaire-schema'

import OwnershipFields from './ownership-fields'
import RecordsSection, { RecordsSubSectionProps } from './records-section'

const PublicShareholdings = ({
  collection,
  sectionActive,
  saveProbateEstateField,
}: RecordsSubSectionProps) => {
  const { total, sole, joint } = getItemsTotals(
    collection.items as ProbateEstateItem[]
  )

  return (
    <RecordsSection
      heading="2.6 Public shareholdings and investments"
      cardType="Holding or investment"
      addLabel="Add holding or investment"
      toggleName="publicShareholdingsSectionActive"
      sectionActive={sectionActive}
      saveProbateEstateField={saveProbateEstateField}
      collection={collection}
      schema={PUBLIC_SHAREHOLDING_SCHEMA}
      totals={{ total, sole, joint }}
      renderFields={({ handleSave }) => (
        <>
          <Grid.Item span={12}>
            <InputFloating
              name="providerName"
              label="Holding company name"
              handleSave={handleSave}
            />
          </Grid.Item>
          <Grid.Item span={12}>
            <InputFloating
              name="referenceNumber"
              label="Reference number"
              handleSave={handleSave}
            />
          </Grid.Item>
          <Grid.Item span={12}>
            <InputFloating
              name="stockbrokerName"
              label="Stockbroker name"
              handleSave={handleSave}
            />
          </Grid.Item>
          <Grid.Item span={12}>
            <InputFloating
              name="value"
              label="Value (£)"
              isCurrency
              handleSave={handleSave}
            />
          </Grid.Item>
          <OwnershipFields handleSave={handleSave} />
        </>
      )}
    />
  )
}

export default PublicShareholdings
